<template lang='pug'>
.report-meters
  h2 电力使用情况
  filter-chart(type='line', :data='get_data("electricity")', :options='options("耗电量 (千瓦时/天)")', :presets='presets1', current='floors', :height='600')

  h2 水力使用情况
  filter-chart(type='line', :data='get_data("water")', :options='options("用水量 (吨/天)")', :presets='presets2', current='all')

  h2 能耗收益
  filter-chart(type='line', :data='benifits()', :options='options("收益/元")', :presets='presets3', current='days')
</template>

<script>
import { FilterChart } from '../charts'
import colors from '../charts/colors'

const DATE_FORMAT = 'YYYY年MM月DD日'

export default {
  name: 'report-meters',
  components: {
    FilterChart,
  },
  data() {
    return {
      presets1: [
        { key: 'all', label: '全部' },
        { key: 'floors', label: '楼层', shows: ['lift', '1f_express', '4f', '5f_common', '6f', '7f_common'] },
        { key: '7f', label: '7F详情', shows: ['7f_kitchen', '7f_cafe', '7f_gym', '7f_car_cube', '7f_common', '8f_water', '8f_hot_water'] },
        { key: 'none', label: '无', shows: [] },
      ],
      presets2: [
        { key: 'all', label: '全部' },
        { key: 'none', label: '无', shows: [] },
      ],
      presets3: [
        { key: 'days',
          label: '每日收益',
          shows: [
            'total_price_per_day',
            'hot_water_per_day',
            'water_per_day',
            'kitchen_price_per_day',
            'electricity_price_per_day',
          ],
        },
        { key: 'tons',
          label: '每吨收益',
          shows: [
            'hot_water_per_ton',
            'water_per_ton',
            'electricity_price_per_walt',
          ],
        },
      ],
    }
  },
  computed: {
    records() {
      return this.$store.state.summary.meter_records
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    options(yLabel) {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'left',
        },
        tooltips: {
          mode: 'point',
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              format: DATE_FORMAT,
              round: 'day',
            },
          }],
          yAxes: [{
            gridLines: {
              display: true,
              drawBorder: true,
            },
            scaleLabel: {
              display: true,
              labelString: yLabel,
            },
          }],
        },
      }
    },
    load() {
      this.$store.dispatch('load_meter_records', this)
    },
    dataset(type) {
      const data = {}
      let previous_record = null
      for (const record of this.records) {
        if (previous_record) {
          const deltatime = new Date(record.time_created) - new Date(previous_record.time_created)
          for (const key of Object.keys(record[type])) {
            if (!data[key])
              data[key] = []
            const delta = record[type][key] - previous_record[type][key]
            const per_day = (delta / deltatime) * 86400000
            data[key].push(per_day)
          }
        }
        previous_record = record
      }
      return data
    },
    get_data(type) {
      const datasets = []
      const data = this.dataset(type)

      let previous_record = null
      for (const record of this.records) {
        if (previous_record) {
          const deltatime = new Date(record.time_created) - new Date(previous_record.time_created)
          for (const key of Object.keys(record[type])) {
            if (!data[key])
              data[key] = []
            const delta = record[type][key] - previous_record[type][key]
            const per_day = (delta / deltatime) * 86400000
            data[key].push(per_day)
          }
        }
        previous_record = record
      }

      let i = 0
      for (const key of Object.keys(data)) {
        const color = colors[i++]
        datasets.push({
          label: (this.$defines.meters[type].meters[key] || this.$defines.meters[type].computed[key] || {}).label,
          data: data[key],
          key,
          fill: false,
          borderWidth: 2,
          pointRadius: 1.5,
          borderColor: color,
          backgroundColor: color,
        })
      }

      return {
        labels: this.records.slice(1).map(r => this.$moment(r.time_created).format(DATE_FORMAT)),
        datasets,
      }
    },
    benifits() {
      const datasets = []
      const water = this.dataset('water')
      const electricity = this.dataset('electricity')

      const data = {
        hot_water_per_day: [],
        hot_water_per_ton: [],
        water_per_day: [],
        water_per_ton: [],
        kitchen_price_per_day: [],
        electricity_price_per_day: [],
        electricity_price_per_walt: [],
        total_price_per_day: [],
      }

      const labels = {
        total_price_per_day: '合计收益/元/日',
        hot_water_per_day: '热水收益/元/日',
        kitchen_price_per_day: '厨房收益/元/日',
        electricity_price_per_day: '电力收益/元/日',
        water_per_day: '冷水总表/元/日',
        hot_water_per_ton: '热水收益/元/吨',
        electricity_price_per_walt: '电力收益/元/度',
        water_per_ton: '冷水总表/元/吨',
      }

      for (let i = 0; i < this.records.length - 1; i++) {
        const hot_water_price_per_day = (water.hot_water[i] * (35 - 6)) - (electricity['8f_hot_water'][i] * 1.4)
        const water_price_per_day = (water.master[i] * (6 - 4.4)) - (electricity['8f_water'][i] * 1.4)
        const kitchen_price_per_day = (electricity['7f_kitchen'][i] * (2 - 1.4)) - (water.kitchen[i] * 6)
        const electricity_floors_per_day = electricity['4f'][i] + electricity['5f_common'][i] + electricity['6f'][i] + electricity['7f_common'][i]
        const electricity_usage_per_day = electricity.master[i] - electricity['8f'][i]
        const electricity_price_per_day = (electricity_floors_per_day * 1.4) - (electricity_usage_per_day * 1.2)
        data.hot_water_per_day.push(hot_water_price_per_day)
        data.hot_water_per_ton.push(hot_water_price_per_day / water.hot_water[i])
        data.water_per_day.push(water_price_per_day)
        data.water_per_ton.push(water_price_per_day / water.master[i])
        data.kitchen_price_per_day.push(kitchen_price_per_day)
        data.electricity_price_per_day.push(electricity_price_per_day)
        data.electricity_price_per_walt.push(electricity_price_per_day / electricity_floors_per_day)
        data.total_price_per_day.push(hot_water_price_per_day + water_price_per_day + kitchen_price_per_day + electricity_price_per_day)
      }

      let i = 0
      for (const key of Object.keys(data)) {
        const color = colors[i++]
        datasets.push({
          label: labels[key],
          key,
          data: data[key],
          fill: false,
          borderWidth: 2,
          pointRadius: 1.5,
          borderColor: color,
          backgroundColor: color,
        })
      }

      return {
        labels: this.records.slice(1).map(r => this.$moment(r.time_created).format(DATE_FORMAT)),
        datasets,
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// Meters.vue?08174158